import m from 'mithril';

interface PageAttrs {
    title: string;
}

/**
 * The two pages other than the menu, in nav order.
 *
 * Routes stay on the default `#!` prefix. Clean URLs would need the host to
 * rewrite unknown paths to index.html, and the bucket behind Cloudflare serves
 * files as they are — a deep link to /scenarios would 404.
 */
const NAV = [
    { href: '/termcomparison', label: 'Cost vs repayment' },
    { href: '/scenarios', label: 'Options' },
];

/**
 * The shell every page below the menu shares: a masthead that gets you home and
 * across to the other page — the pages were dead ends before — above a
 * width-constrained column. `.page` caps the width, body's `justify-center`
 * centres it.
 */
export const Page: m.Component<PageAttrs> = {
    view: ({ attrs: { title }, children }) =>
        m(
            '.page',
            m(
                'header.masthead',
                m(
                    m.route.Link,
                    { selector: 'a.masthead__home', href: '/' },
                    'Mortgages',
                ),
                m(
                    'nav.masthead__nav',
                    NAV.map(({ href, label }) =>
                        m(
                            m.route.Link,
                            {
                                selector: 'a.masthead__link',
                                href,
                                class:
                                    m.route.get() === href
                                        ? 'masthead__link--current'
                                        : '',
                                'aria-current':
                                    m.route.get() === href ? 'page' : undefined,
                            },
                            label,
                        ),
                    ),
                ),
            ),
            m('h1.page-title', title),
            children,
        ),
};
